import * as React from 'react';
import { withRouter } from 'react-router-dom';

@withRouter
class PrivacyPolicy extends React.Component {
    render() {
        return (
        	<div class="container">
<p>
    <h1 class="text-left">Privacy Policy</h1>
</p>
<p>
    <a href="https://www.anesthesiascheduler.com/">www.soteriatec.com</a>
</p>
<p> 
    <br/>
    This privacy policy has been compiled to better serve those who are
    concerned with how their 'Personally Identifiable Information' (PII) is
    being used online. PII, as described in US privacy law and information
    security, is information that can be used on its own or with other
    information to identify, contact, or locate a single person, or to identify
    an individual in context. Please read our privacy policy carefully to get a
    clear understanding of how we collect, use, protect or otherwise handle
    your Personally Identifiable Information in accordance with our website.
</p>
    <h3>
        What personal information do we collect from the people that visit our
        blog, website or app?
    </h3>
<p>
    When registering or entering our site, as appropriate, you may be asked to
    enter your email address, phone number or other details to help you with
    your experience. This is the only way we will be able to guarantee that
    only data that you can see will be presented to you.
</p>
    <h3>When do we collect information?</h3>
<p>
    We collect information from you when you register on our site or mobile app
    or enter information on our site. This is vital for making sure that the
    information you entered, and requested, is related to you.
</p>
    <h3>How do we use your information?</h3>
<p>
    We may use the information we collect from you when you register, sign up
    for our newsletter, respond to a survey or marketing communication, surf
    the website, or use certain other site features in the following ways:
</p>
    <ul>
        <li>
            To personalize your experience and to allow us to deliver the type of
            content which you are most interested.
    </li>
        <li>
            To quickly process your transactions.
        </li>   
    </ul>

<p>
</p>
    <h3>How do we protect your information?</h3>
<p>
    Your personal information is contained behind secured networks and is only
    accessible by a limited number of persons who have special access rights to
    such systems and are required to keep the information confidential. In
    addition, all sensitive information you supply is encrypted via Secure
    Socket Layer (SSL) technology.
    <br/>
    We implement a variety of security measures when a user enters, submits, or
    accesses their information to maintain the safety of your personal
    information.
</p>
    <h3>Do we use 'cookies'?</h3>
<p>
    Yes. Cookies are small files that a site or its service provider transfers
    to your computer's hard drive through your Web browser (if you allow) that
    enables the site's or service provider's systems to recognize your browser
    and capture and remember certain information. For instance, we use cookies
    to help us remember you and your preferences. They are also used to help us
    understand your preferences based on previous or current site activity,
    which enables us to provide you with improved services. We also use cookies
    to help us compile aggregate data about site traffic and site interaction
    so that we can offer better site experiences and tools in the future.
</p>
    <h3>We use cookies to:</h3>
<ul>
    <li>
        Understand and save user's preferences for future visits.
    </li>
</ul>
<p>
    <br/>
    You can choose to have your computer warn you each time a cookie is being
    sent, or you can choose to turn off all cookies. You do this through your
    browser settings. Since browsers are different, look at your browser's Help
    Menu to learn the correct way to modify your cookies.
    <br/>
    If you turn cookies off, it won't affect the user's experience.
</p>
    <h3>Third-party disclosure</h3>
<p>
    We do not sell, trade, or otherwise transfer to outside parties your
    Personally Identifiable Information.
</p>
    <h3>Third-party links</h3>
<p>
    We do not include or offer third-party products or services on our website.
</p>
    <h3>Google</h3>
<p>
    Google's advertising requirements can be summed up by Google's Advertising
    Principles. They are put in place to provide a positive experience for
    users. We have not enabled Google AdSense on our site, but we may do so in
    the future. 
    <a
        href="https://support.google.com/adwordspolicy/answer/1316548?hl=en"
        target="_blank"
    >
         Google Ads Policy
    </a>
</p>
    <h3>How does our site handle Do Not Track signals?</h3>
<p>
    We honor Do Not Track signals and Do Not Track, plant cookies, or use
    advertising when a Do Not Track (DNT) browser mechanism is in place.
</p>
    <h3>Does our site allow third-party behavioral tracking?</h3>
<p>
    It's also important to note that we do not allow third-party behavioral
    tracking
</p>
    <h3>Fair Information Practices</h3>
<p>
    The Fair Information Practices Principles form the backbone of privacy law
    in the United States and the concepts they include have played a
    significant role in the development of data protection laws around the
    globe. Understanding the Fair Information Practice Principles and how they
    should be implemented is critical to comply with the various privacy laws
    that protect personal information.
</p>
    <h3>
        In order to be in line with Fair Information Practices we will take the
        following responsive action, should a data breach occur:
    </h3>
<p>
    We will notify you via email
</p>
<ul>
    <li>
        Within 7 business days
    </li>
</ul>
<p>
    <br/>
    We will notify the users via in-site notification.
    <br/>
    We also agree to the Individual Redress Principle which requires that
    individuals have the right to legally pursue enforceable rights against
    data collectors and processors who fail to adhere to the law. This
    principle requires not only that individuals have enforceable rights
    against data users, but also that individuals have recourse to courts or
    government agencies to investigate and/or prosecute non-compliance by data
    processors.
</p>
<p>
    <h3>Contacting Us</h3>
</p>
<p>
    If there are any questions regarding this privacy policy, you may contact
    us using the information below.
    <br/>
    <br/>
    1491 Edgewood Rd
    <br/>
    Lake Forest, Illinois 60045
    <br/>
    USA
    <br/>
    info@soteriatec.com
</p>
<br/>
        	</div>
    	)
    }
}

export { PrivacyPolicy }


// WEBPACK FOOTER //
// ./src/pages/PrivacyPolicy.js